<template>
  <div class="tips">
    <div class="box">
      <div class="lottie"></div>
      <i class="cursor" @click="close"></i>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web-limi";
export default {
  name: "tips",
  data() {
    return {
        interval:null,
    };
  },
  created() {
    this.$nextTick(this.animInit);
  },
  methods: {
    animInit() {
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie"),
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: "/static/lottie/playbackAlert/data.json",
      });
      this.interval = setTimeout(this.close,3000)
    },
    close(){
        clearTimeout(this.interval);
        this.anim && this.anim.destroy();
        this.anim = null;
        this.$emit('close');
    }
  },
  beforeDestroy(){
      this.close();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.tips {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
}
.box {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -198px;
  margin-top: -198px;
  width: 396px;
  height: 396px;
  .lottie {
    width: 100%;
    height: 342px;
  }
  i {
    width: 44px;
    height: 44px;
    display: block;
    background: url("../../../assets/img/common/close.png");
    background-size: cover;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/playback/tips.vue